import React from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { ScanRequestActionCell } from "../../utils";
import { ScanCompletedConfig } from "./ScanCompletedTableConfig";
import { Table } from "@components/common/table/Table";
import { useScanRequests } from "@piiqtechnologies/ui-lib";
import { sort } from "@utils/sort";
import { useNavigate } from "react-router-dom";
import { PATHS } from "@constants/Paths";
import { PeekChip } from "@piiqtechnologies/ui-components";
const onSiteScanRequest = "Scan request created from scanner while on-site";
const ScanCompletedActions = ({ scanRequest, isCover = false }) => {
    const intl = useIntl();
    if (!isCover || scanRequest.accessDetails !== onSiteScanRequest) {
        return React.createElement(ScanRequestActionCell, { key: scanRequest._id, scanRequest: scanRequest });
    }
    if (scanRequest.accessDetails === onSiteScanRequest) {
        return (React.createElement(PeekChip, { color: "primary", variant: "outlined", size: "medium", label: intl.formatMessage(messages.onsiteRequest) }));
    }
    return;
};
export const ScanCompletedTable = ({ dateRange, searchKey, communities, isAdminTable = false }) => {
    const intl = useIntl();
    const navigate = useNavigate();
    const scanRequestsAPI = useScanRequests();
    const { scanCompletedParams, scanCompletedColumns } = ScanCompletedConfig({
        communities: communities,
        isAdminTable: isAdminTable,
        dateRange: dateRange,
        debouncedSearchKey: searchKey,
    });
    const goToSpace = (id) => {
        navigate(`${PATHS.SPACES}${PATHS.UNIT}/${id}`);
    };
    return (React.createElement(Table, { api: scanRequestsAPI, apiConfig: {
            params: scanCompletedParams,
            serverSidePagination: false,
            serverSideSorting: false,
        }, onClick: (row) => !isAdminTable && goToSpace(row.space._id), columns: scanCompletedColumns, actions: (row) => [ScanCompletedActions({ scanRequest: row, isAdmin: isAdminTable })], actionsCover: (row) => [ScanCompletedActions({ scanRequest: row, isCover: true, isAdmin: isAdminTable })], notFoundMessage: intl.formatMessage(messages.noScanCompleted), 
        // @ts-ignore
        sortPredicate: sort() }));
};
export default ScanCompletedTable;
